export const constants = {
    isTouch: "ontouchstart" in window ? function () {document.body.classList.add("touch"); return true;}() : function () {document.body.classList.add("no-touch"); return false;}(),
    isIOS: (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) ? function () {document.body.classList.add("ios"); return true;}() : function () {document.body.classList.add("no-ios"); return false;}()
};

export function headerFunction() {
    let  html = $('html');

    $('.header').on('click', '.open-nav', function (e) {
        e.preventDefault();
        html.toggleClass('show-nav');
    });
}

(function () {
  $('.frontier').on('click', '.media-block', function () {
    if (parseInt(window.innerWidth) <= 1024) {
      $(this).parent().find('.open-video').trigger('click');
    }
  })
})();


// WEBPACK FOOTER //
// ./assets/js/modules/module.js